import React from 'react';
function Stats() {
    return ( 
        <div className="container p-6 mb-5">
         <div className="row p-6">
            <div className="col-12 col-lg-6 p-3 p-lg-6">
             <h1 className="fs-2 mb-5">Trust with confidence</h1>
             <h2 className="fs-4">Customer-first always</h2>
             <p className="text-muted">That's why 1.3+ crore customers trust INVESTRO with ₹3.5+ lakh crores worth of equity investments.</p>  
             <h2 className="fs-4">No spam or gimmicks</h2>
             <p className="text-muted">No gimmicks, spam, "gamification", or annoying push notifications. High quality apps that you use at your pace, the way you like.</p>
             <h2 className="fs-4">The INVESTRO universe</h2>
             <p className="text-muted">Not just an app, but a whole ecosystem. Our investments in 30+ fintech startups offer you tailored services specific to your needs.</p>
             <h2 className="fs-4">Do better with money</h2>
             <p className="text-muted">With initiatives like Nudge and Kill Switch, we don't just facilitate transactions, but actively help you do better with your money.</p>
            </div>
            <div className="col-12 col-lg-6 p-3 p-lg-6 mb-5 text-center text-lg-start">
                <img src="media/images/ecosystem.png" className="img-fluid mb-4" alt="INVESTRO ecosystem" style={{maxWidth: "90%"}} />
                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                    <a href="" style={{textDecoration: "none"}}>Explore Our products<i className="fa-solid fa-arrow-right-long mx-2"></i></a>
                    <a href="" style={{textDecoration: "none"}}>Try kit demo<i className="fa-solid fa-arrow-right-long mx-2"></i></a>
                </div>
            </div>

         </div>
        </div>
     );
}

export default Stats;